import LoadingIcon from "assets/icons/loading.svg?react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import classNames from "classnames";

const Spinner: FC<Props> = ({ className }) => (
  <LoadingIcon className={classNames(styles.icon, className)} />
);

export default Spinner;
